/**
 * Defaults para Feedback (Alertas, Tooltips, Chips)
 */

export const feedbackDefaults: Record<string, Record<string, unknown> | undefined> = {
  VAlert: {
    variant: 'tonal',
    rounded: 'lg',
    elevation: 0,
  },

  VSnackbar: {
    rounded: 'lg',
    elevation: 6,
    timeout: 4000,
    VBtn: {
      variant: 'text',
      size: 'small',
    },
  },

  VBanner: {
    rounded: 'lg',
    elevation: 0,
  },

  VChip: {
    rounded: 'lg',
    elevation: 0,
  },

  VBadge: {
    rounded: 'circle',
    color: 'error',
  },

  VTooltip: {
    location: 'top',
    openDelay: 200,
  },

  VMenu: {
    rounded: 'lg',
    elevation: 4,
    offset: 8,
  },

  VList: {
    rounded: 'lg',
    density: 'comfortable',
  },

  VListItem: {
    rounded: 'lg',
  },

  VProgressLinear: {
    color: 'primary',
    height: 4,
    rounded: true,
  },

  VProgressCircular: {
    color: 'primary',
    width: 4,
  },

  VSkeletonLoader: {
    elevation: 0,
  },
}
